module.exports = __webpack_public_path__ + "img/Next_black.16742e95.svg";